import LoginCallback from './LoginCallback';
import { authRoles } from 'app/auth';

export const LoginCallbackConfig = {
    settings: {
        layout: {
            config: {
                navbar: {
                    display: false
                },
                toolbar: {
                    display: false
                },
                footer: {
                    display: false
                },
                leftSidePanel: {
                    display: false
                },
                rightSidePanel: {
                    display: false
                }
            }
        }
    },
    auth: authRoles.onlyGuest,
    routes: [
        {
            path: ['/login/callback', '/users/login/callback'],
            component: LoginCallback
        }
    ]
};
